var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 25.647,
    viewBox: "0 0 29 25.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LabTest",
    transform: "translate(-1091.493 -104.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M1113.64,120.039c0-4.1-7.446-14.29-7.446-14.29s-7.447,10.188-7.447,14.29a7.447,7.447,0,0,0,14.893,0Z",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_955",
    "data-name": "Line 955",
    x2: 6.688,
    transform: "translate(1091.993 126.727)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_956",
    "data-name": "Line 956",
    x2: 23.074,
    transform: "translate(1095.181 130.048)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_957",
    "data-name": "Line 957",
    x2: 4.236,
    transform: "translate(1111.812 109.583)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_958",
    "data-name": "Line 958",
    x2: 9.765,
    transform: "translate(1110.229 105.748)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M1110.653,115.4a11.305,11.305,0,0,1-1.986,4.1,8.979,8.979,0,0,1-6.352,3.3,9.692,9.692,0,0,1-1.606-.045,6.111,6.111,0,0,0,11.593-2.7A12.314,12.314,0,0,0,1110.653,115.4Z",
    fill: "#ffc524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTest);
export default __webpack_public_path__ + "static/media/LabTest.e118c20b875a5b1cb095b28059f5e7f0.svg";
export { ForwardRef as ReactComponent };